import React, { useContext } from 'react';
import { useDeviationViewContext } from '../../../Context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import DesktopDeviationPage from '../../DesktopDeviationPage';
import FullscreenDeviationPage from '../../FullscreenDeviationPage';
import MobileDeviationPage from '../../MobileDeviationPage';
import { getDeviationType, isLegacyStatus, } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import SimplePage from '../SimplePage';
import DesktopTextualPage from '../../DesktopTextualPage';
import DesktopStatusPage from '../../DesktopStatusPage';
var DeviationPageContent = function (_a) {
    var deviation = _a.deviation;
    var isMobile = useContext(MobileContext);
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isDeviationPostsFlagEnabled = useFlag('deviation_posts');
    if (isMobile) {
        return React.createElement(MobileDeviationPage, { deviation: deviation });
    }
    if (isFullscreen) {
        return React.createElement(FullscreenDeviationPage, { deviation: deviation });
    }
    switch (getDeviationType(deviation)) {
        case DeviationTypes.COMMISSION:
            return React.createElement(SimplePage, { deviation: deviation, withSidebar: false });
        case DeviationTypes.STATUS:
            if (isDeviationPostsFlagEnabled && !isLegacyStatus(deviation)) {
                return React.createElement(DesktopStatusPage, { deviation: deviation });
            }
            return React.createElement(SimplePage, { deviation: deviation });
        case DeviationTypes.POLL:
            return React.createElement(SimplePage, { deviation: deviation });
        case DeviationTypes.JOURNAL:
        case DeviationTypes.LITERATURE:
            return React.createElement(DesktopTextualPage, { deviation: deviation });
        default:
            return React.createElement(DesktopDeviationPage, { deviation: deviation });
    }
};
DeviationPageContent.displayName = 'DeviationPageContent';
export default DeviationPageContent;
//# sourceMappingURL=DeviationPageContent.js.map